import { render } from "./D_modiMemoPop.vue?vue&type=template&id=23357e5a&scoped=true"
import script from "./D_modiMemoPop.vue?vue&type=script&lang=js"
export * from "./D_modiMemoPop.vue?vue&type=script&lang=js"

import "./D_modiMemoPop.vue?vue&type=style&index=0&id=23357e5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23357e5a"]])

export default __exports__